var bankValues = {
    xs: 11,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
};
var getBaseIconSize = function (variant) {
    switch (variant) {
        case 'bank':
            return bankValues;
        default:
            return bankValues;
    }
};
var iconSize = function (baseIconSize) { return ({
    xs: "".concat(baseIconSize.xs, "px"),
    sm: "".concat(baseIconSize.sm, "px"),
    md: "".concat(baseIconSize.md, "px"),
    lg: "".concat(baseIconSize.lg, "px"),
    xl: "".concat(baseIconSize.xl, "px"),
}); };
var getIconSize = function (variant) {
    return iconSize(getBaseIconSize(variant));
};
export { getBaseIconSize, getIconSize };
//# sourceMappingURL=iconSizes.js.map